module.exports = __webpack_public_path__ + "static/img/ket-thumb.094321e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/ket-thumb.jpg
// module id = FRtX
// module chunks = 0